export const areaCodeHelperText = (countryIso: string): string =>
  countryIso === "AU"
    ? "Specify the single digit area code prefix (e.g. 2 for NSW landlines or 4 for mobile phones) used to provision campaigns' Caller ID (the number that campaign calls will originate from)"
    : "Specify the three digit area code prefix used to provision campaigns' Caller ID (the number that campaign calls will originate from)";

export const callerPhoneInAreaCodeHelperText = (countryIso: string): string =>
  `Override the ${
    countryIso === "AU" ? "single" : "three"
  } digit area code prefix used to provision the audio-over-phone number provided to callers. Useful to override if there are limited numbers in the Default Caller ID area code.`;
